import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const AdminSidebar = ({ isOpen }) => {
  const location = useLocation();

  const groupedSections = [
    {
      title: 'About Us',
      items: [
        { name: 'Board Members', path: '/admin/board-members' },
        { name: 'Management Team', path: '/admin/management-team' },
        { name: 'Timeline', path: '/admin/timeline' },
        { name: 'Awards', path: '/admin/awards' },
        { name: 'Memberships', path: '/admin/memberships' },
      ]
    },
    {
      title: 'Contacts',
      items: [
        { name: 'Tenders', path: '/admin/tenders' },
      ]
    },
    {
      title: 'Our Business',
      items: [
        { name: 'Services', path: '/admin/services' },
        { name: 'Subsidiaries', path: '/admin/subsidiaries' },
      ]
    },
    {
      title: 'Governance',
      items: [
        { name: 'Policies', path: '/admin/policies' },
        { name: 'Whistleblower Info', path: '/admin/whistleblower' },
      ]
    },
    {
      title: 'Media',
      items: [
        { name: 'Newsfeed', path: '/admin/newsfeed' },
        { name: 'Our Stories', path: '/admin/our-stories' },
      ]
    },
    {
      title: 'Careers',
      items: [
        { name: 'Job Openings', path: '/admin/job-openings' },
      ]
    },
    {
      title: 'Reports & Submissions',
      items: [
        { name: 'Career Applications', path: '/admin/reports/career' },
        { name: 'Contact Messages', path: '/admin/reports/contact' },
      ]
    }
  ];

  return (
    <div className={`fixed inset-y-0 left-0 z-40 w-72 bg-[#28357B] text-white transition-transform duration-300 ease-in-out transform lg:translate-x-0 ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}>
      <div className="p-6 border-b border-[#3d4b96] flex items-center justify-center h-16">
        <Link to="/admin/dashboard" className="flex items-center gap-2 text-xl font-bold text-white">
          <img src="/assets/images/logo/kssb.png" alt="Semesta Logo" className="h-7 w-auto" />
          <span className="text-2xl font-semibold uppercase font-rubik text-white">Semesta</span>
        </Link>
      </div>
      <nav className="p-4 overflow-y-auto h-[calc(100vh-4rem)]">
        <ul className="space-y-6">
          {/* Dashboard - Not Grouped */}
          <li>
            <Link
              to="/admin/dashboard"
              className={`block px-4 py-2 rounded transition-colors ${location.pathname === '/admin/dashboard'
                  ? 'bg-[#FDA729] text-white font-medium'
                  : 'text-gray-300 hover:bg-[#3d4b96] hover:text-white'
                }`}
            >
              Dashboard
            </Link>
          </li>

          {groupedSections.map((group, index) => (
            <li key={index}>
              {group.title && (
                <h3 className="px-4 text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">
                  {group.title}
                </h3>
              )}
              <ul className="space-y-1">
                {group.items.map((item) => (
                  <li key={item.path}>
                    <Link
                      to={item.path}
                      className={`block px-4 py-2 rounded transition-colors ${location.pathname === item.path
                          ? 'bg-[#FDA729] text-white font-medium'
                          : 'text-gray-300 hover:bg-[#3d4b96] hover:text-white'
                        }`}
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default AdminSidebar;
